var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceOnline01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010002;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,210.8c-57.2,0-109.4,29.1-139.5,77.3c-7,12-4,27.1,8,34.1s27.1,4,34.1-8 c21.1-34.1,57.2-54.2,96.3-54.2s75.3,20.1,96.3,54.2c5,8,13,12,21.1,12c5,0,9-1,13-4c12-7,15.1-23.1,8-34.1 C364.9,239.9,312.7,210.8,255.5,210.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.3,227.9C441.1,145.6,352.8,96.5,255.5,96.5S70.9,145.6,19.7,227.9c-7,12-4,27.1,8,34.1 c12,7,27.1,4,34.1-8c42.1-67.2,114.4-107.4,193.6-107.4S407,186.8,449.2,254c5,8,13,12,21.1,12c5,0,9-1,13-4 C496.3,255,499.3,238.9,492.3,227.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 255.5,
    cy: 374.4,
    r: 41.1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOnline01);
export default __webpack_public_path__ + "static/media/deviceOnline-01.3bfc261fbf6daf813335f97c32408d29.svg";
export { ForwardRef as ReactComponent };